import React from 'react';
import StudentFormCreate from './StudentFormCreate';
import StudentFormEdit from './StudentFormEdit';

/**
 * 学生表单包装组件（向后兼容）
 * @deprecated 请直接使用 StudentFormCreate 或 StudentFormEdit
 * 
 * 此组件保留用于向后兼容，新代码应该：
 * - 新增学生：使用 StudentFormCreate
 * - 编辑学生：使用 StudentFormEdit
 */
const StudentFormView = ({ editMode = false, initialData = {}, isSaving = false, onBack, onSave, onTokenAccess }) => {
  // 根据 editMode 渲染对应的专用组件
  if (editMode) {
    return (
      <StudentFormEdit
        initialData={initialData}
        isSaving={isSaving}
        onBack={onBack}
        onSave={onSave}
        onTokenAccess={onTokenAccess}
      />
    );
  }

  return (
    <StudentFormCreate
      isSaving={isSaving}
      onBack={onBack}
      onSave={onSave}
    />
  );
};

export default StudentFormView;
